import { LoadingButton } from '@mui/lab';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  DialogContentText,
} from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { UserAndContact } from 'types/UsersAndContact.types';

function ConfirmDeleteModal({
  open,
  setOpen,
  onConfirm,
  loading,
}: {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<UserAndContact | boolean>>;
  onConfirm: () => void;
  loading?: boolean;
}) {
  const { t } = useTranslation('_common');

  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      PaperProps={{
        sx: { width: 750 },
      }}
    >
      <DialogTitle>{t('confirmation')}</DialogTitle>

      <DialogContent>
        <DialogContentText>{t('confirm_delete_text')}</DialogContentText>
      </DialogContent>
      <Divider />
      <DialogActions>
        <Button onClick={() => setOpen(false)}>{t('cancel')}</Button>
        <LoadingButton variant="contained" onClick={() => onConfirm()} loading={loading}>
          {t('confirm')}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}

export default ConfirmDeleteModal;
